import { Container, Grid, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material";

export const Footer: React.FC = () => {
  const footerFontSize = "12px";
  const footerYear = new Date().getFullYear();
  const footerBuild = process.env.REACT_APP_COMMIT_HASH?.substring(0, 7);

  return (
    <Container>
      <Grid
        container
        height="10px"
        justifyContent="center"
        alignItems="center"
        columnSpacing={2}
      >
        <Grid item>
          <Typography fontSize={footerFontSize}>
            © {footerYear} MAPS Research
          </Typography>
        </Grid>
        <Grid item>
          <Typography fontSize={footerFontSize}>
            Build: {footerBuild}
          </Typography>
        </Grid>
        <Grid item>
          <Typography fontSize={footerFontSize}>
            <Link component={RouterLink} to="/consent">
              Consent Form
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};
